var map = {
	"./view/client/client.module": [
		"./src/app/view/client/client.module.ts",
		"view-client-client-module"
	],
	"./view/company/company.module": [
		"./src/app/view/company/company.module.ts",
		"common",
		"view-company-company-module"
	],
	"./view/dashboard/dashboard.module": [
		"./src/app/view/dashboard/dashboard.module.ts",
		"view-dashboard-dashboard-module"
	],
	"./view/event/event.module": [
		"./src/app/view/event/event.module.ts",
		"view-event-event-module"
	],
	"./view/pos-user/pos-user.module": [
		"./src/app/view/pos-user/pos-user.module.ts",
		"view-pos-user-pos-user-module"
	],
	"./view/pos/pos.module": [
		"./src/app/view/pos/pos.module.ts",
		"view-pos-pos-module"
	],
	"./view/profile/profile.module": [
		"./src/app/view/profile/profile.module.ts",
		"view-profile-profile-module"
	],
	"./view/report/report.module": [
		"./src/app/view/report/report.module.ts",
		"view-report-report-module"
	],
	"./view/session/session.module": [
		"./src/app/view/session/session.module.ts",
		"view-session-session-module"
	],
	"./view/token/token.module": [
		"./src/app/view/token/token.module.ts",
		"view-token-token-module"
	],
	"./view/transaction/transaction.module": [
		"./src/app/view/transaction/transaction.module.ts",
		"view-transaction-transaction-module"
	],
	"./view/user/user.module": [
		"./src/app/view/user/user.module.ts",
		"common",
		"view-user-user-module"
	],
	"./view/voucher/voucher.module": [
		"./src/app/view/voucher/voucher.module.ts",
		"view-voucher-voucher-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;